import { RadioGroupButtonOptionsType } from '../../components/RadioGroup/radioGroup.buttons'
import { Chips } from '../../components/Chips/Chips'

export const routing = {
  general: 'general',
  contract_categories: 'contract_categories'
}

export const getSubtabs = (count?: number): RadioGroupButtonOptionsType[] => {
  return [
    {
      label: 'General',
      value: routing.general
    },
    {
      label: (
        <span>
          Contract categories{' '}
          {typeof count === 'number' && (
            <Chips.Menu>{count > 100 ? '99+' : count}</Chips.Menu>
          )}
        </span>
      ),
      value: routing.contract_categories
    }
  ]
}
